var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavoutiesActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4922_1897)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5997 3.72014C13.5997 4.02617 13.5997 4.3356 13.5997 4.64163C13.5498 4.67903 13.5598 4.74024 13.5565 4.78784C13.46 5.54612 13.1673 6.22619 12.7582 6.85865C12.1928 7.73594 11.4677 8.46361 10.7127 9.16408C9.62847 10.1706 8.50096 11.1227 7.3934 12.1054C7.32688 12.1632 7.25703 12.221 7.18054 12.2652C6.87454 12.4352 6.53862 12.3876 6.24593 12.136C5.80025 11.7483 5.35789 11.3607 4.91886 10.9697C3.9643 10.1298 2.98978 9.30689 2.09841 8.3922C1.41991 7.69513 0.78797 6.95386 0.40548 6.03577C-0.22646 4.50901 -0.133332 3.02647 0.764688 1.63233C1.58621 0.3606 3.15608 -0.254862 4.60954 0.0987738C5.49426 0.312995 6.17608 0.843448 6.72155 1.57112C6.78474 1.65613 6.81468 1.66973 6.88452 1.57452C7.17721 1.16648 7.53309 0.823046 7.95217 0.551019C8.73045 0.0477687 9.57858 -0.0984459 10.4833 0.0681707C11.1651 0.193983 11.7671 0.493213 12.276 0.969261C12.9245 1.57112 13.317 2.326 13.5033 3.19648C13.5365 3.3699 13.5265 3.55352 13.5997 3.72014Z",
    fill: "#744FFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4922_1897"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.6,
    height: 12.3636,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoutiesActive);
export default __webpack_public_path__ + "static/media/favoutiesActive.0ecadbad1e4aa63cf9a285fe6ac33586.svg";
export { ForwardRef as ReactComponent };